import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";

export interface Workout {
  name: string;
  date: string;
  duration: string;
  distance: string;
  intensity: "High" | "Medium" | "Low";
  practiceId?: string;
}

interface RecentTrainingSetsCardProps {
  workouts: Workout[];
  onWorkoutClick?: (workout: Workout) => void;
}

/**
 * Card component displaying recent training sets/workouts
 */
export function RecentTrainingSetsCard({ workouts, onWorkoutClick }: RecentTrainingSetsCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Training Sets</CardTitle>
        <CardDescription>Your latest workouts and performance</CardDescription>
      </CardHeader>

      <CardContent>
        <div className="space-y-4">
          {workouts.map((workout, index) => (
            <div
              key={index}
              className={`flex items-center justify-between p-4 rounded-lg border ${
                onWorkoutClick ? "cursor-pointer hover:bg-muted/40 transition-colors" : ""
              }`}
              role={onWorkoutClick ? "button" : undefined}
              tabIndex={onWorkoutClick ? 0 : -1}
              onClick={() => onWorkoutClick?.(workout)}
              onKeyDown={(e) => {
                if (!onWorkoutClick) return;
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onWorkoutClick(workout);
                }
              }}
            >
              <div className="space-y-1">
                <p className="font-medium">{workout.name}</p>
                <p className="text-sm text-muted-foreground">
                  {workout.date} • {workout.duration} • {workout.distance}
                </p>
              </div>

              <Badge
                variant={
                  workout.intensity === "High"
                    ? "default"
                    : workout.intensity === "Medium"
                    ? "secondary"
                    : "outline"
                }
              > 
                {workout.intensity}
              </Badge>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}

